import React from 'react';

export default function Footer() {
  const wa = '5492616815848';
  const waUrl = `https://wa.me/${wa}`;

  return (
    <footer className="w-full border-t border-purple-100 bg-white/40 backdrop-blur-sm py-4 mt-8">
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-end gap-4 text-sm text-gray-700">
        <div className="font-medium">
          Desarrollado por{' '}
          <a
            href="https://plantasoftware.com.ar/"
            target="_blank"
            rel="noreferrer"
            className="font-semibold text-purple-700 hover:text-purple-900 hover:underline"
          >
            Planta Software
          </a>
        </div>
        <a
          href={waUrl}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 text-green-600 hover:text-green-700 font-medium"
          aria-label="Contactar por WhatsApp"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor" aria-hidden="true">
            <path d="M20.52 3.48A11.87 11.87 0 0012 .5C6.21.5 1.5 5.21 1.5 11c0 1.96.51 3.86 1.47 5.55L.5 23.5l6.98-1.82A11.87 11.87 0 0012 22.5c5.79 0 10.5-4.71 10.5-10.5 0-3.02-1.18-5.82-3.98-7.52zM12 20.5c-1.07 0-2.12-.24-3.08-.7l-.22-.11-4.15 1.09 1.12-3.98-.14-.25A8.37 8.37 0 013.5 11c0-4.7 3.8-8.5 8.5-8.5 4.7 0 8.5 3.8 8.5 8.5S16.7 20.5 12 20.5z" />
            <path d="M17.44 14.03c-.29-.14-1.71-.84-1.98-.94-.27-.1-.47-.14-.67.14-.19.29-.73.94-.9 1.13-.16.19-.33.21-.62.07-.29-.14-1.22-.45-2.32-1.43-.86-.77-1.44-1.72-1.61-2.01-.17-.29-.02-.45.13-.6.13-.13.29-.33.43-.5.14-.17.19-.28.29-.47.1-.19.05-.35-.02-.49-.07-.14-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.19 0-.5.07-.76.34-.26.26-1 1-1 2.44 0 1.44 1.03 2.83 1.17 3.03.14.19 2.02 3.09 4.9 4.33 2.67 1.13 2.67.75 3.15.7.48-.05 1.55-.63 1.77-1.24.22-.61.22-1.12.15-1.24-.07-.12-.27-.19-.56-.33z" />
          </svg>
          Contacto
        </a>
      </div>
    </footer>
  );
}
